import type { CloudEnvironmentStorage } from "../types/CloudEnvironmentStorage";
import { CachingCloudEnvironmentStorageDecorator } from "./CachingCloudEnvironmentStorageDecorator";
import { LocalStorageCloudEnvironmentStorage } from "./LocalStorageCloudEnvironmentStorage";

let cloudEnvironmentStorage: CloudEnvironmentStorage;

export function getCloudEnvironmentStorage(): CloudEnvironmentStorage {
    if (!cloudEnvironmentStorage) {
        cloudEnvironmentStorage = new CachingCloudEnvironmentStorageDecorator(new LocalStorageCloudEnvironmentStorage());
    }
    
    return cloudEnvironmentStorage;
}
